import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'
import { RbacAccessDenied } from '~/components/routes/administration/roles/access-denied'
import { CamerasPage } from '~/components/routes/cameras/page/cameras-page'
import {
  CAMERA_OPERATOR_LEGACY_RIGHTS,
  CAMERA_STREAM_READ,
} from '~/components/routes/cameras/permissions'
import { useMigratedRight, withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/cameras/new')({
  staticData: {
    permission: CAMERA_STREAM_READ,
  },
  component: CamerasNewPage,
  validateSearch: z.object({
    storeId: z.number().int().positive().optional(),
    focusedCameraId: z.number().int().positive().optional(),
    mode: z.enum(['boutique', 'views']).optional(),
    viewId: z.string().optional(),
  }),
})

withRoutePermissions(Route)

function CamerasNewPage() {
  const canRead = useMigratedRight(CAMERA_STREAM_READ, CAMERA_OPERATOR_LEGACY_RIGHTS)

  if (!canRead) return <RbacAccessDenied />

  return <CamerasPage />
}
